import React from "react";
import AreaReport from "./AreaReport"; // ✅ Import reusable component

const Input = () => <AreaReport areaKey="input" color="#457b9d" />; // ✅ Use Input's color
export default Input;